/**
 *  _ __  _____      _______      __   ___ ___  _ __ ___
 * | '_ \/ __\ \ /\ / / _ \ \ /\ / /  / __/ _ \| '__/ _ \
 * | | | \__ \\ V  V / (_) \ V  V /  | (_| (_) | | |  __/
 * |_| |_|___(_)_/\_/ \___/ \_/\_/    \___\___/|_|  \___|
 *
 * ns.wow WordPress components
 * by Neidhart + Schön Group
 */

// Bundle polyfills for ns.wow plugins and theme

import "core-js";
import "object-fit-polyfill";
import "promise-polyfill";
import "smoothscroll-polyfill";
import "url-search-params-polyfill";
import "whatwg-fetch";

// Bundle plugin module (NSCore)

import { createHooks } from '@wordpress/hooks';
import Platform from './Platform.js';
import Countdown from './Countdown.js';

const Hooks = createHooks();

export default {

  version: () => {
    return NSContext.plugins.core.version;
  },

  getSiteUrl: () => {
    return Platform.getSiteUrl();
  },

  getAjaxUrl: () => {
    return Platform.getAjaxUrl();
  },

  getRestUrl: () => {
    return Platform.getRestUrl();
  },

  getPluginUrl: () => {
    return Platform.getPluginUrl();
  },

  getThemeUrl: () => {
    return Platform.getThemeUrl();
  },

  // Façade for @wordpress/hooks

  addAction: (hookName, callback, priority = 10) => {
    return Hooks.addAction(hookName, 'default', callback, priority);
  },

  addFilter: (hookName, callback, priority = 10) => {
    return Hooks.addFilter(hookName, 'default', callback, priority);
  },

  removeAction: (hookName) => {
    return Hooks.removeAction(hookName, 'default');
  },

  removeFilter: (hookName) => {
    return Hooks.removeFilter(hookName, 'default');
  },

  hasAction: (hookName) => {
    return Hooks.hasAction(hookName, 'default');
  },

  hasFilter: (hookName) => {
    return Hooks.hasFilter(hookName, 'default');
  },

  removeAllActions: (hookName) => {
    return Hooks.removeAllActions(hookName);
  },

  removeAllFilters: (hookName) => {
    return Hooks.removeAllFilters(hookName);
  },

  doAction: (hookName, ...args) => {
    return Hooks.doAction(hookName, ...args);
  },

  applyFilters: (hookName, ...args) => {
    return Hooks.applyFilters(hookName, ...args);
  },

  doingAction: (hookName) => {
    return Hooks.doingAction(hookName);
  },

  doingFilter: (hookName) => {
    return Hooks.doingFilter(hookName);
  },

  didAction: (hookName) => {
    return Hooks.didAction(hookName);
  },

  didFilter: (hookName) => {
    return Hooks.didFilter(hookName);
  },

  actions: Hooks.actions,

  filters: Hooks.filters

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

	// Adminbar: Clear cache

	if (document.getElementById('refresh-cache')) {
		Platform.initRefreshCache();
	}

	// Countdown for Go-Live screen

	if (document.getElementById('ns-countdown')) {
		Countdown.init();
	}

	// Bugfix for ACFML: Disable select elements in copied fields
	// Copied select fields must be edited in the main language,
	// but should selectable in other languages, ACFML doens't handle that,
	// which is confusing for the user. So we disable them and re-enable before submit.

	document.querySelectorAll('.acfml-field-copied select').forEach(function(select) {
		select.disabled = true;
	});

});
